import * as Sentry from '@sentry/angular';
import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Data, NavigationEnd, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { BehaviorSubject, EMPTY, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: "root",
})
export class SliderManagerService {
  public sliderManagerSlidesData = new BehaviorSubject({});
  public currentSlideData = new BehaviorSubject("");
  private previousUrl: string;
  private currentUrl: string;
  private lastRouteSubscription: Subscription;
  public alias$ = new BehaviorSubject("");
  private dataSubscription: Subscription;

  constructor(private authService: AuthService, private router: Router, private afAuth: AngularFireAuth) {
    this.afAuth.onAuthStateChanged(
      (user) => {
        if (user) {
          this.loadInitialData();
        }
      },
      (err) => {
        return err;
      }
    );
  }

  private loadInitialData(): void {
    this.dataSubscription?.unsubscribe();
    this.dataSubscription = this.authService
      .getAngularFireStore("/Global_lookup/slidermanager", "snapshotChanges")
      .pipe(
        map((res: Data) => {
          const data = res?.data();
          if (!data) {
            return null;
          }
          return data;
        }),
        catchError((err) => {
          Sentry.captureException(err, { tags: { service: 'slider-manager' } });
          return EMPTY;
        })
      )
      .subscribe({
        next: (data) => {
          if (!data || !data.slide) {
            return;
          }
          this.sliderManagerSlidesData.next(data.slide);
        },
      });
  }



  public trackLastRoute(): void {
    this.lastRouteSubscription?.unsubscribe();
    this.currentUrl = this.router.url;
    this.lastRouteSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  public clearLastRouteSubscription(): void {
    this.previousUrl = "";
    this.lastRouteSubscription?.unsubscribe();
  }

  public getPreviousUrl(): string {
    return this.previousUrl;
  }
}